import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const StudentDashboard = lazyPage(() => import('@/pages/student/Dashboard'));
const StudentMyProfile = lazyPage(() => import('@/pages/student/MyProfile'));
const StudentMyTimetable = lazyPage(() => import('@/pages/student/MyTimetable'));
const StudentMySubjects = lazyPage(() => import('@/pages/student/MySubjects'));
const StudentAttendance = lazyPage(() => import('@/pages/student/Attendance'));
const StudentAssignments = lazyPage(() => import('@/pages/student/Assignments'));
const StudentHomework = lazyPage(() => import('@/pages/student/Homework'));
const StudentExamsResults = lazyPage(() => import('@/pages/student/ExamsResults'));
const StudentHallTicket = lazyPage(() => import('@/pages/student/HallTicket'));
const StudentPerformancePage = lazyPage(() => import('@/pages/student/Performance'));
const StudentFeesPayments = lazyPage(() => import('@/pages/student/FeesPayments'));
const StudentLibrary = lazyPage(() => import('@/pages/student/Library'));
const StudentTransport = lazyPage(() => import('@/pages/student/Transport'));
const StudentMedical = lazyPage(() => import('@/pages/student/Medical'));
const StudentCertificates = lazyPage(() => import('@/pages/student/Certificates'));
const StudentMessages = lazyPage(() => import('@/pages/student/Messages'));

export const studentRoutes: AppRoute[] = [
  {
    path: 'student',
    title: 'Student Portal',
    children: [
      { path: '', title: 'Student Portal', redirectTo: '/student/dashboard' },
      { path: 'dashboard', title: 'Dashboard', component: StudentDashboard },
      { path: 'profile', title: 'My Profile', component: StudentMyProfile },
      // The profile menu's link: under no Fabrica menu, so every signed-in student reaches their own profile.
      { path: 'my-profile', title: 'My Profile', component: StudentMyProfile },
      { path: 'timetable', title: 'My Timetable', component: StudentMyTimetable },
      { path: 'subjects', title: 'My Subjects', component: StudentMySubjects },
      { path: 'attendance', title: 'Attendance', component: StudentAttendance },
      { path: 'assignments', title: 'Assignments', component: StudentAssignments },
      { path: 'homework', title: 'Homework', component: StudentHomework },
      { path: 'exams', title: 'Exams & Results', component: StudentExamsResults },
      { path: 'hall-ticket', title: 'Hall Ticket', component: StudentHallTicket },
      { path: 'performance', title: 'Performance', component: StudentPerformancePage },
      { path: 'fees', title: 'Fees & Payments', component: StudentFeesPayments },
      { path: 'library', title: 'Library', component: StudentLibrary },
      { path: 'transport', title: 'Transport', component: StudentTransport },
      { path: 'medical', title: 'Medical', component: StudentMedical },
      { path: 'certificates', title: 'Certificates', component: StudentCertificates },
      { path: 'messages', title: 'Messages', component: StudentMessages },
    ],
  },
];
